import { TAvailableConfigValues } from '@customTypes/common';

export interface IPlaybackSpeedWatcherConfig {
  maxLiveSyncThreshold: number;
  minLiveSyncThreshold: number;
  maxTargetBufferMultiplier: number;
  targetBufferInitialMultiplier: number;
  targetBufferDecreaseCoefficient: number;
}

export const defaultPlaybackSpeedWatcherConfig: IPlaybackSpeedWatcherConfig = {
  maxLiveSyncThreshold: 0.4,
  minLiveSyncThreshold: 0.3,
  maxTargetBufferMultiplier: 3,
  targetBufferInitialMultiplier: 1,
  targetBufferDecreaseCoefficient: 0.25,
};

export const availablePlaybackSpeedWatcherConfigValues: TAvailableConfigValues<IPlaybackSpeedWatcherConfig> = {};
